import * as coreAxios from "axios";
import localStorageStore from "./localStorageStore";

const baseUrl = process.env.REACT_APP_API_HOST;

export const axios = coreAxios.default.create({
  baseURL: baseUrl,
});

export const axiosInterceptor = () => {
  axios.interceptors.request.use(async (request) => {
    const authToken = localStorageStore.getToken();

    if (authToken) {
      request["headers"]["Authorization"] = `Bearer ${authToken}`;
    }
    if (!(request.data instanceof FormData)) {
      request["headers"]["Content-Type"] = `application/json`;
    }
    request["mode"] = "cors";

    return request;
  });

  // Response interceptors

  axios.interceptors.response.use(
    async (response) => {
      if (!response.data) {
        return response;
      }

      return response.data;
    },
    (error) => {
      const { response } = error;

      if (response) {
        const { status } = response;

        if (status === 401) {
          // Clear the session before leaving, not just the address.
          //
          // Sending the browser to "/" while the dead token sat in
          // localStorage put the app in a loop: Login saw isAuthenticated
          // and a cached user, sent it straight back to /dashboard, that
          // 401ed, and round it went. The screen looked logged in with no
          // data on it, and logout could not finish because the hard
          // navigation kept interrupting it. A token the server has
          // rejected is not a session.
          localStorage.clear();
          setTimeout(() => {
            window.location.href = "/login";
          }, 300);
        }
      }

      // Surface the server's own message: every caller shows err.message,
      // and a 409 with candidates (catalogue near-match) carries err.data.
      const body = response && response.data;
      const wrapped = new Error((body && body.message) || error.message);
      wrapped.status = response && response.status;
      wrapped.data = body || null;
      wrapped.candidates = body && body.candidates;
      return Promise.reject(wrapped);
    }
  );
};

axiosInterceptor();
